import { render, staticRenderFns } from "./DraftListEditB2.vue?vue&type=template&id=463d4082"
import script from "./DraftListEditB2.vue?vue&type=script&lang=js"
export * from "./DraftListEditB2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports